const useClassesDefaultValue = (classes)=>{
    if (!classes?.length) return;
    return classes[0];
};
export default useClassesDefaultValue;

//# sourceMappingURL=useClassesDefaultValue.js.map